export const GET_ADMINS = 'GET_ADMINS';
export const UPDATE_ADMIN = 'UPDATE_ADMIN';
export const ADD_ADMIN = 'ADD_ADMIN';
export const DELETE_ADMIN = 'DELETE_ADMIN';
export const SET_ADMINS = 'SET_ADMINS';
export const SET_LOADING = 'SET_LOADING';
export const ADD_ADMIN_REQUEST = 'ADD_ADMIN_REQUEST';
export const DELETE_ADMIN_REQUEST = 'DELETE_ADMIN_REQUEST';

export const getAdmins = () => ({ type: GET_ADMINS });
export const setAdmins = (data) => ({ type: SET_ADMINS, data });
export const updateAdmin = (data) => ({ type: UPDATE_ADMIN, data });
export const addAdmin = (data) => ({ type: ADD_ADMIN, data });
export const deleteAdmin = (data) => ({ type: DELETE_ADMIN, data });
export const setLoading = (data) => ({ type: SET_LOADING, data });
export const addAdminRequest = (data) => ({ type: ADD_ADMIN_REQUEST, data });
export const deleteAdminRequest = (data) => ({
  type: DELETE_ADMIN_REQUEST,
  data,
});
